import { reduce, head, get, round } from 'lodash'

const shortDisplays = {
  'EUR': '€',
  'USD': '$'
};

const formatMoney = (money, useShortCurrency = false, precision = 2) => {
  let amount = round(money.amount, precision).toFixed(precision);
  const splitAmount = amount.split('.');
  if(splitAmount[1] == '00') {
    amount = splitAmount[0];
  }
  const shortCurrency = shortDisplays[money.currency];
  if(useShortCurrency && shortCurrency) {
    return `${shortCurrency}${amount}`
  }
  return amount + " " + money.currency;
};

const calculateItemTotal = (price, quantity) => {
  return {
    amount: price.amount * quantity,
    currency: price.currency
  }
};

const calculateCartTotal = (cart, precision = 2) => {
  const cartItems = cart && cart.contents;
  let total = 0;
  const currency = get(head(cartItems) || {}, 'price.currency', null);
  if(cartItems && cartItems.length > 0) {
    const totalAmount = reduce(cartItems, (sum, item) => {
      return sum + ( item.price.amount * item.quantity )
    }, 0);

    total += totalAmount
  }

  if(cart.shipping_method && cart.shipping_price) {
    total += cart.shipping_price.amount || 0
  }

  if(cart.service_fee) {
    total += cart.service_fee.amount || 0
  }

  if(cart.discount_amount) {
    total -= cart.discount_amount.amount || 0
  }

  return {
    amount: round(total, precision),
    currency
  }
  // return {amount: 0};
};

export { formatMoney, calculateItemTotal, calculateCartTotal }